import styled from "styled-components";
import colors from "assets/styles/colors";

export default styled.div`
    display: flex;
    align-items: center;

    .weight-display {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
    }

    .weight-green {
        color: ${colors.accentGreen};
    }

    .weight-red {
        color: ${colors.accentRed};
    }

    .edit-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .mode-selector {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .mode-option {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
        font-size: 13px;
        color: ${(props) => props.theme.text};

        input[type="radio"] {
            cursor: pointer;
        }
    }

    .weight-input {
        width: 80px;
        padding: 4px 8px;
        border: 1px solid ${colors.grey70};
        border-radius: 4px;
        font-size: 14px;
        background-color: ${(props) => props.theme.inputBackground};
        color: ${(props) => props.theme.text};

        &:focus {
            outline: none;
            border-color: ${colors.textTeal};
        }
    }

    .live-weight-preview {
        font-size: 14px;
        color: ${colors.textTeal};
        font-weight: 500;
    }

    .rationale-field {
        display: flex;
        flex-direction: column;
        gap: 2px;
        width: 240px;
    }

    .rationale-label {
        font-size: 12px;
    }

    .rationale-optional {
        color: ${colors.grey70};
    }

    .rationale-input {
        padding: 6px 8px;
        border: 1px solid ${colors.grey70};
        border-radius: 4px;
        font-size: 13px;
        font-family: inherit;
        resize: vertical;
        min-height: 32px;
        max-height: 140px;

        &:focus {
            outline: none;
            border-color: ${colors.textTeal};
        }
    }

    .rationale-counter {
        align-self: flex-end;
        font-size: 11px;
        color: ${colors.grey70};
    }

    .action-buttons {
        display: flex;
        gap: 8px;
    }

    .action-btn {
        padding: 4px 10px;
        border: none;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;

        &.edit,
        &.save {
            background-color: ${colors.textTeal};
            color: white;

            &:hover {
                background-color: ${colors.textNavyDark};
            }
        }

        &.edit:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        &.cancel {
            background-color: ${colors.grey80};
            color: ${colors.grey30};

            &:hover {
                background-color: ${colors.grey70};
            }
        }
    }
`;
